import { History } from '../../../types/history';
import { ApiAbstract } from '../abstract';

export class ApiHistory extends ApiAbstract<any, History> {}
